import { useEffect, useState } from 'react';
import { AnimatePresence } from 'motion/react';
import { useAuthStore } from '@/features/auth/store/auth-store';
import { toast } from '@/lib/hooks/use-toast';
import { TITULO_DE_PLAN_CONVERTIDO } from '../animaciones/momentos';
import { modoDeEscena } from '../animaciones/modo-de-animacion';
import { EVENTO_PLAN_CONVERTIDO, olvidarQueFueDemo, recienConvertida } from '../empresa-demo';
import { sincronizarBienvenidaTrasConvertir } from '../bienvenida-tras-convertir';
import { CapaDeMomento } from './capa-de-momento';

/**
 * Momento 5 (spec 344): lo que ve el comercio el día que la plataforma lo convierte. Sin
 * la marca de `guardarEmpresaDemo` esto no pide nada: una empresa que nunca fue demo no
 * baja el 3D. El aviso existe porque `/me` puede contestar con la app ya montada.
 */
/** El 3D no se vio: el aviso de texto sale una sola vez y recién entonces se olvida la marca. */
function avisarYOlvidar() {
  if (!recienConvertida() || useAuthStore.getState().isImpersonating) return;
  toast({ title: TITULO_DE_PLAN_CONVERTIDO, variant: 'success' });
  olvidarQueFueDemo();
}

export function PlanConvertido() {
  const [ver, setVer] = useState(false);

  useEffect(() => {
    const revisar = () => {
      // Soporte mira: el momento sigue guardado para el comercio.
      if (!recienConvertida() || useAuthStore.getState().isImpersonating) return;
      // La bienvenida genérica no es para quien viene de la demo (decisión de Sebastián, 2-nov).
      void sincronizarBienvenidaTrasConvertir();
      if (modoDeEscena() === 'animada') setVer(true);
      else avisarYOlvidar();
    };
    revisar();
    window.addEventListener(EVENTO_PLAN_CONVERTIDO, revisar);
    return () => window.removeEventListener(EVENTO_PLAN_CONVERTIDO, revisar);
  }, []);

  return (
    <AnimatePresence>
      {ver && (
        <CapaDeMomento
          momento="plan-convertido"
          className="fixed inset-x-3 bottom-3 z-40 w-auto md:inset-x-auto md:bottom-5 md:left-[268px] md:w-[300px]"
          alListo={olvidarQueFueDemo}
          alNoSeVio={avisarYOlvidar}
          alCerrar={() => setVer(false)}
        />
      )}
    </AnimatePresence>
  );
}
